import { useEffect } from "react";

/**
 * Closes a popover the way people expect one to close: a press anywhere
 * outside `ref`, or Escape. Listens only while `open`, so a closed menu costs
 * nothing.
 */
export const useDismiss = (ref, open, close) => {
  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) close();
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") close();
    };

    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [ref, open, close]);
};
